import { render, staticRenderFns } from "./base_particulars.vue?vue&type=template&id=58dbbee4&scoped=true&"
import script from "./base_particulars.vue?vue&type=script&lang=js&"
export * from "./base_particulars.vue?vue&type=script&lang=js&"
import style0 from "./base_particulars.vue?vue&type=style&index=0&id=58dbbee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dbbee4",
  null
  
)

export default component.exports